import gql from 'graphql-tag';

export const GET_PLAN_BILLING_INFO = gql`
  query GetPlanBillingInfo($id: Int!) {
    plan(id: $id) {
      id
      billable
    }
  }
`;

export const getPlanBillingInfoMock = {
  plan: {
    __typename: 'Plan',
    billable: true,
    id: 1,
  },
};

export const GET_STATE_DATA = gql`
  query GetStateData($planId: Int!) {
    plan(id: $planId) {
      id
      active
      utilityAccounts {
        id
        serviceAddressZip
        utility {
          id
          state {
            id
            activeAdvocacyCampaign {
              callToActionText
              editableBody
              id
              isDefault
              legislationDescription
              numberOfSubmissions
              shareText
              subjectLine
              successMessage
              successTitle
              uneditableBody
            }
            mostRecentCompletedAdvocacyCampaign {
              id
              message
              title
            }
            vnmSolarProjectsStatistics {
              expectedKwh
              numberOfProjects
              totalNumberOfMembers
            }
          }
        }
      }
    }
  }
`;

export const getStateDataMock = {
  plan: {
    id: 1,
    utilityAccounts: [
      {
        id: 1,
        utility: {
          id: 1,
          state: {
            activeAdvocacyCampaign: {
              callToActionText: 'Do it!',
              editableBody: 'Things the customer might want to write to a rep.',
              id: 1,
              isDefault: true,
              legislationDescription:
                'This bill will bring community solar to your state.',
              numberOfSubmissions: 32,
              shareText: 'Join me in supporting community solar legislation',
              subjectLine: 'Vote for community solar',
              successMessage: 'Thank you for your support!',
              successTitle: 'You supported clean energy legislation',
              uneditableBody:
                'Things the customer will definitely write to a rep.',
            },
            id: 2,
            mostRecentCompletedAdvocacyCampaign: {
              id: 1,
              message: 'Community Solar Passed!',
              title: 'We won!',
            },
            vnmSolarProjectsStatistics: {
              expectedKwh: 100000.34903,
              numberOfProjects: 34,
              totalNumberOfMembers: 5000,
            },
          },
        },
      },
    ],
  },
};

export const GET_VNM_SOLAR_PROJECTS_BY_STATE = gql`
  query GetVnmSolarProjectsByState($stateId: Int!) {
    vnmSolarProjectsByState(stateId: $stateId) {
      id
      latitude
      longitude
      name
      active @client
      startDate
      totalCapacity
    }
  }
`;

export const getVnmSolarProjectsByStateMock = {
  vnmSolarProjectsByState: [
    {
      active: true,
      id: 1,
      latitude: 12,
      longitude: 20,
      name: 'One',
      startDate: new Date(),
      totalCapacity: 3030,
    },
    {
      active: true,
      id: 2,
      latitude: 13,
      longitude: 20,
      name: 'Two',
      startDate: new Date(),
      totalCapacity: 4040,
    },
    {
      active: false,
      id: 3,
      latitude: null,
      longitude: null,
      name: 'Three',
      startDate: new Date(),
      totalCapacity: 5050,
    },
  ],
};

export const HAS_ADVOCACY_SUBMISSION = gql`
  query hasAdvocacyCampaignSubmission(
    $userId: Int!
    $advocacyCampaignId: Int!
  ) {
    hasAdvocacyCampaignSubmission(
      userId: $userId
      advocacyCampaignId: $advocacyCampaignId
    )
  }
`;

export const hasAdvocacySubmissionMock = {
  hasAdvocacyCampaignSubmission: false,
};

export const hasAdvocacySubmissionTrueMock = {
  hasAdvocacyCampaignSubmission: true,
};
